export class GetAllDemandAction {
  static readonly type = '[Demand] Get All';
  constructor() {}
}
